/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import CustomLink from "../../components/Link";
import Context from "../../scripts/context/User";

export default function TwoFALogin({ state, setState, setTwoFA }) {
  const navigate = useNavigate();
  const { setGlobalState, getRegistrationStep } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!state.one_time_password || state.one_time_password.length !== 6) return;
    setLoading(true);

    setErrorMessage("");
    axios
      .post("2fa/check", state)
      .then(({ data }) => {
        toast.success(data.message);
        if (state.remember_me) {
          localStorage.setItem("token", data.token);
        } else {
          sessionStorage.setItem("token", data.token);
        }
        setGlobalState({
          ...state,
          user: {
            ...data.user,
          },
          redirect_uri: data.redirect_uri,
          registration_step: getRegistrationStep(data.redirect_uri),
        });
        setLoading(false);
        data.redirect_uri && navigate(data.redirect_uri);
      })
      .catch(({ response }) => {
        setErrorMessage(response.data.message);
        setLoading(false);
      });
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="login login-3 login-signin-on d-flex flex-row-fluid">
        <div
          className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
          style={{
            backgroundImage:
              "radial-gradient(50% 50% at 50% 50%, rgba(33, 114, 229, 0.3) 0%, rgb(70 132 167 / 0%) 100%)",
            backgroundColor: "rgb(1, 16, 37)",
          }}
        >
          <div className="login-form text-center text-white p-7 position-relative overflow-hidden">
            <div className="d-flex flex-center mb-15">
              <CustomLink to="/">
                <img src="img/logo.svg" className="h-50px" alt="" />
              </CustomLink>
            </div>
            <div className="login-signin">
              <div className="mb-10">
                <h3>Welcome</h3>
                <p className="opacity-60 font-weight-bold">
                  Enter Your Google Authentication Code.
                </p>
              </div>
              <form className="form text-left" onSubmit={handleSubmit}>
                <div className="mm-number-Auth">
                  <div className="mm-number-container">
                    <div className="mm-number-input">
                      <div className="mm-number-input-container animated">
                        <VerificationInput
                          length={6}
                          onChange={(value) => {
                            if (loading) return;
                            setState({
                              ...state,
                              one_time_password: value,
                            });
                          }}
                          value={state.one_time_password}
                          placeholder="."
                          autoFocus
                        />
                      </div>
                    </div>
                  </div>
                  {errorMessage && (
                    <p className="error-msg show mt-4">{errorMessage}</p>
                  )}
                  <div className="form-group mt-15 d-flex justify-content-center">
                    <button
                      id="kt_login_forgot_submit"
                      className="btn btn-pill btn-white font-weight-bold opacity-90 px-15 py-3 m-2 just-white"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Confirm
                    </button>
                    <button
                      id="kt_login_forgot_cancel"
                      className="btn btn-pill btn-outline-white font-weight-bold opacity-70 px-15 py-3 m-2"
                      onClick={() => setTwoFA(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
